import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

// FRS 4.2.1 revision 20260826 (Q8) - 1 แถวในโซน = 1 VRF System (ไม่มี quantity ที่ระดับ
// placement อีกต่อไป - จำนวนถูกกำหนดไว้แล้วที่ตัว VRF System) จึงไม่มีการแก้ไข (edit) placement
export const ACTION = {
  LIST: 'LIST_ZONE_VRF',
  CREATE: 'CREATE_ZONE_VRF',
  DELETE: 'DELETE_ZONE_VRF',
};

export const searchVRFInZone = (
  pageSize,
  page,
  sorted,
  filtered,
  isPublic,
  zoneId,
) => {
  const zoneParams =
    zoneId === null ? { zone_id__is_null: true } : { zone_id: zoneId };
  return RestClient.request({
    method: 'get',
    url: Constants.API_ZONE_VRF,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => (sort.desc ? `-${sort.id}` : sort.id)).join(',')
        : null,
      is_public: isPublic,
      ...zoneParams,
    },
  });
};

export const listVRFInZone = (
  pageSize,
  page,
  sorted,
  filtered,
  isPublic,
  zoneId,
) => ({
  type: ACTION.LIST,
  payload: searchVRFInZone(
    pageSize,
    page,
    sorted,
    filtered,
    isPublic,
    zoneId,
  ).catch(err => Promise.reject(err.response.data)),
});

export const addVRFToZone = (vrfSystemId, zoneId) => {
  const formData = new FormData();
  formData.set('vrf_system_id', vrfSystemId);
  formData.set('zone_id', zoneId);
  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_ZONE_VRF,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const removeVRFFromZone = id => ({
  type: ACTION.DELETE,
  payload: RestClient.request({
    method: 'delete',
    url: `${Constants.API_ZONE_VRF}${id}/`,
  })
    .then(() => ({ id }))
    .catch(err => Promise.reject(err.response.data)),
});



// WEBPACK FOOTER //
// ./src/redux/zone/zone_vrf_actions.js